<template>
<div class="chapter">
<div class="inner_page">
<h1 class="western4" id="calibre_toc_4">Chapter Two</h1>
<h1 class="western7">Head Count</h1>
<p class="c4"> <br class="calibre1"/></p>
<p class="c4">A jump of static on his radio pulled Cahz away from
scanning the terrain.</p>
<p class="western5">“Don’t know what make worst noise—you or the
dead,” Angel announced.</p>
<p class="western5">Cahz cast a look around, puzzled by the
Russian sniper’s comment.</p>
<p class="western5">“You come down here and say that, Angel!”
came Bates’ angry response.</p>
<p class="western5">Cahz craned his neck to see Bates down on the
ground. The young soldier was standing in the middle of the car
park where he’d been dropped off, the capture net beneath his feet.
Cahz grinned as he heard Angel let loose some Russian obscenity.
Bates, agitated, stood with one foot atop his battered ghetto
blaster, gesturing at a nearby office block, his weapon slack by
his side. It was a good natured exchange of insults, but it was
just that kind of lapse of concentration that got people
killed.</p>
<p class="western5">“Stay on station, Bates,” Cahz said, breaking
into the exchange.</p>
<p class="western5">“Angel, speak English!” Bates replied,
ignoring Cahz.</p>
<p class="western5">“Burak!” Angel cursed.</p>
<p class="western5">“Oh, that’s it!” Bates voice hissed over the
radio. “I know what that one means! I’m coming up there to kick
your ass—”</p>
<p class="western5">“Bates!” Cahz snapped. “Stay on station.”</p>
<p class="western5">“Roger that, boss,” came back Bates’ cowed
response.</p>
<p class="western5">“Those two are like my parents,” Idris
offered.</p>
<p class="western5">Cannon laughed, remembering the end of the
gag.</p>
<p class="western5">“They argue a lot and don’t have sex?” Idris
offered.</p>
<p class="western5">Cahz didn’t respond. He was still looking out
of the window at Bates on the ground. The wisecracking soldier was
still looking agitated on the cargo net. It was all displacement,
Cahz knew, a distraction from the reality of their surroundings.
You needed a certain level of detachment to visit these ghost
cities, but too much and you became oblivious to the dangers
shambling around.</p>
<p class="western5">Again the blurt of static grabbed Cahz’s
attention.</p>
<p class="western5">“Bait, this is Angel. One Whisky Delta, seven
o’clock, one hundred yards out.”</p>
<p class="western5">“Don’t start with me!” The frustration in
Bates voice was obvious even through the poor radio communication.
“Don’t call me bait! You know it makes me jumpy.”</p>
<p class="western5">“Is your name,” came Angel’s response, the
sarcasm dripping from her Eastern European accent.</p>
<p class="western5">“It’s <i class="calibre3">Batesssss</i>! You leave out the S
on purpose.”</p>
<p class="western5">Cahz whispered “Fuck sake,” before toggling
his mic.</p>
<p class="western5">“Bates, Angel, this is Lieutenant Cahzalid.
You will observe proper radio discipline. Is that clear? No more
horseshit!”</p>
<p class="western5">After a few seconds Bates replied to Angel’s
contact using the proper protocol.</p>
<p class="western5">Confirming she understood Cahz’s annoyance,
but without admitting her part Angel too reported back, “This is
Angel. Multiple contacts all vectors.”</p>
<p class="western5">“What’s the count, Angel?” Cahz asked, but
before he could get an answer a shot rung out.</p>
<p class="western5">He whipped round trying to ascertain the
threat. He couldn’t see where the shot had come from nor its
intended target.</p>
<p class="western5">“Did you see anything?” he asked the other
occupants of the chopper.</p>
<p class="western5">“Can’t see anything kicking off, boss.”
Cannon admitted.</p>
<p class="western5">“Who fired?!” Cahz barked into his mic.</p>
<p class="western5">“Me sir,” Bates replied.</p>
<p class="western5">Cahz looked down at Bates through the glass
foot well of the helicopter. “What the hell was that for? I didn’t
see any W.D.’s in your immediate vicinity.”</p>
<p class="western5">“No, there weren’t,” Bates said. “Caught one
that looked like John Prage a hundred yards out. I just had to pop
one in his head.”</p>
<p class="western5">“Who the fuck is John Prage?” Cahz
immediately realised he’d regret asking that question. “No, forget
it. We don’t have time. Angel, say again. What are the
numbers?”</p>
<p class="western5">Bates didn’t hear or didn’t care that Cahz
didn’t want to know. “He was this prick I used to work with. If
anybody deserved to get bit it was him.”</p>
<p class="western5">“Shut the fuck up, Bates, or you’re on
report,” Cahz snapped.</p>
<p class="western5">Bates had the sense not to cut in.</p>
<p class="western5">Cahz repeated his question: “Angel, what’s
the count?”</p>
<p class="western5">“Too many, sir. Suggest we abort and find
clearer ground,” Angel reported. “There’s also smoke. W.D. must
have set off something flammable.”</p>
<p class="western5">Cahz looked over at Idris, the helicopter
pilot. “Spin us around to get a look.”</p>
<p class="western5">“Sure,” Idris replied.</p>
<p class="western5">The chopper dipped slightly and made a gentle
turn.</p>
<p class="western5">Looking out over the ruined city, Cahz could
see a precession of grey corpses snaking their way around the
derelict cars and other debris to the lure below. He craned round
to talk to his right-hand man.</p>
<p class="western5">Cannon had shifted slightly, his head cocked
in the opposite direction from the last time Cahz had looked. The
sour expression Cannon wore owed more to the discomfort than his
gruff disposition.</p>
<p class="western5">Before Cahz could speak, the bear of a man
piped up, “There’s too many of them, boss.”</p>
<p class="western5">“Something must be drawing the Whisky Deltas
in,” Cahz said, thinking out loud.</p>
<p class="western5">“But what, boss?” Cannon asked. “World’s been
dead a long time.”</p>
<p class="western5">“I haven’t seen this many in one place since
that op’ in Norfolk.” Cahz looked through the view port at his
feet, at Bates standing on the cargo net below. “It’s academic
anyway,” he said, more to himself than any of his crew. He turned
to the pilot. “How are we for fuel?”</p>
<p class="western5">“We’re good. Why’d you ask?” Idris said.</p>
<p class="western5">“It’s early and the weather’s clear. If we’ve
got the fuel we can try for an alternative site.”</p>
<p class="western5">Even with the helmet and mic obscuring his
face, Cahz could see Idris suck in his cheeks as he considered the
option.</p>
<p class="western5">“We’ve come pretty far out for the
operational range,” Idris said. “As long as we back tracked and
found something on the way home…” Idris paused for a moment, making
a circling motion with his index finger as he calculated something
in his mind. “Yeah, if we head for home and spot a landing site we
overlooked on the way back I can give you twenty, maybe thirty
minutes.”</p>
<p class="western5">Cahz looked back at Cannon. “What you reckon?
Twenty minutes enough?”</p>
<p class="western5">“Pushing it—we’d be closer to thirty,” Cannon
surmised.</p>
<p class="western5">Cahz checked his watch. It was still early
and he estimated there would be another twelve or so hours of
daylight. He turned his attention to Idris. “If the fuel tanks can
take an extra thirty minutes we’ll still make it back in time for
chow.”</p>
<p class="western5">Idris nodded. “Yeah, if the weather stays
good, half an hour isn’t going to tax the bird too much. But I
don’t need to remind you weather reports aren’t as accurate as they
used to be.”</p>
<p class="western5">“If we spot a viable site on the way back all
well and good. Failing that we miss out on the
employee-of-the-month bonus.”</p>
<p class="western5">Cannon gave a snorting snigger at Cahz’s
quip.</p>
<p class="western5">Cahz flipped the radio on his shoulder to
transmit to the two on the ground. “Angel, Bates, we’re bugging
out. Angel, is your position secure?”</p>
<p class="western5">“Yes, Lieutenant,” Angel replied.</p>
<p class="western5">Cahz addressed everyone over his microphone:
“Let’s move before those W.D.’s and that fire give us cause for
concern.” He looked out of the window at the rolling black clouds
of smoke. “Okay then. Bates, you’re first up. Confirm your harness
is secure and clean.”</p>
<p class="western5">Bates spoke into his radio, “Affirmative,
Lieutenant. We’re good to go.”</p>
<p class="western5">Cahz watched the pockets of smoke. As he
watched, they grew, but they didn’t look like a normal fire. The
smoke seemed to be concentrated into patches rather than carpeting
an area as he would expect. They looked like the Indian smoke
signals from an old western. He hadn’t seen anything on the way in,
and now as he watched, a fifth distinct plume of smoke started to
rise up above the buildings. He couldn’t see the actual fires
behind the ruins and he had no time to investigate.</p>
<p class="western5">“Cahz!” Angel hollered over the radio, a
tremor in her voice. “We’ve got live ones!”</p>
<p class="western5">Cahz, alert from Angel’s exclamation, looked
around at the multitude of undead below. He mulled her words over
in his mind. <i class="calibre3">Live ones.</i> Did she mean the dead were
particularly active or had she spotted survivors?</p>
<p class="western5">“Say again, Angel.”</p>
<p class="western5">“Multiple humans fighting their way toward
Bates. Seven, maybe eight.” Angel’s voice dropped. “Ah jeez, they
just lost one. Coming in on four o’clock.”</p>
<p class="western5">Cannon lent forward from the back of the
chopper. He asked, “What do we do, boss?”</p>
<p class="western5">Cahz looked down at the derelict buildings.
He shifted his position to get a better view of the streets. There
were walking dead down there in the thousands. Is this what
happened to the lost retrieval team? Had they landed trying to save
survivors only to be overwhelmed? Could there be survivors from the
lost team among the living on the ground?</p>
<p class="western5">Cahz cupped the radio mic in his hand.</p>
<p class="western5">“Angel, give them cover fire.”</p>
<p class="western5">
</p><p class="c2">* * *</p>
<p class="western5"> <br class="calibre1"/></p>
<p class="western5">With as much power as he could bring, Ali
swung his steel pipe down on to the back of the zombie’s skull. The
head crumpled, yielding to the force of the pipe. There was a
cylindrical indentation imprinted on its cranium as the zombie
staggered to the ground.</p>
<p class="western5">As it toppled, it’s hands grasped tight to
George’s shirt. Dragged by the extra weight, the old man was pulled
off balance.</p>
<p class="western5">Straining against the fall, the old man let
slip a gurgled moan, a moan all but lost to the guttural cries of
the surrounding undead.</p>
<p class="western5">Ali lashed out with his pipe smacking a
zombie across the temple. He cried, “Ray, help George!”</p>
<p class="western5">Ray bent down, arm outstretched. “George,
George!”</p>
<p class="western5">George recoiled away and grunted.</p>
<p class="western5">“George!” Ray barked as he scooped up his
friend’s frail body. “You’ve got to help, buddy.”</p>
<p class="western5">George didn’t. His face was pale and locked
in a grimace, his right hand clutched to his chest.</p>
<p class="western5">“Move it!” Ali called out between swipes.</p>
<p class="western5">“Chest,” George panted.</p>
<p class="western5">Ray had the old man under the arm and was
hauling him to his feet. He pleaded, “Not now, George, not
now.”</p>
<p class="western5">George gave a heavy shudder and the stiffness
left his body.</p>
<p class="western5">“George?” Ray gasped, staring into the old
man’s watery eyes.</p>
<p class="western5">A withered hand appeared over Ray’s shoulder
and grabbed his coat.</p>
<p class="western5">“Hell!” Ray jumped, letting go of George. He
burled round, shrugging off the zombie’s grasp.</p>
<p class="western5">Unable to see what was going on, Ali called
out, “Ray?!”</p>
<p class="western5">“It’s George,” came Ray’s stunned reply. “I
think he’s dead.”</p>
<p class="western5">Ali reached back and grabbed a fist full of
Ray’s jumper. Pulling him forward, Ali bellowed, “Move it or we’ll
be dead, too!”</p>
<p class="western5">“But… George?” Ray stammered.</p>
<p class="western5">“Move!” Ali commanded as he raised his weapon
again.</p>
<p class="western5">Throwing his arm down he whacked another
walking corpse square on the forehead. There was a crunch and the
lip of the pipe raked down the zombie’s face. The dark skin split
apart, revealing a canyon of yellowed bone framed by the wet muddy
post-mortem flesh.</p>
<p class="western5">“Where are the others?” Ray screeched, his
voice pitched high with terror.</p>
<p class="western5">“Up ahead.” Ali made a small jump into the
air to get a slightly better perspective. “I can see Ryan’s
head.”</p>
<p class="western5">Ray cast around, trying to peer through the
throng of dead cannibals. “Where’s the helicopter?”</p>
<p class="western5">“Shut up and fight!” Ali battered the next
undead assailant out of his path.</p>
<p class="western5">For every zombie Ali floored it seemed that
there were a hundred more closing in on him. The sweat was
streaming down his face, saturating his bushy eyebrows and soaking
into his beard. His shoulder ached, his arm throbbed and his palms
stung from the force of the hammering. The thought of being
devoured alive by these malodorous monsters kept him lashing
out.</p>
<p class="western5">“We’ll never make it,” Ray blurted.</p>
<p class="western5">Ali turned to cajole his friend and as he
looked round he saw a zombie, its teeth bared. It threw itself at
Ray. Too far ahead to do anything, all Ali could do was shout a
warning.</p>
<p class="western5">Just as it was about to chew down on Ray, it
cocked its head as if confused.</p>
<p class="western5">Then it simply keeled over.</p>
<p class="western5">Ali suddenly became aware of shots ringing
out.</p>
<p class="western5">A second zombie was hit. It fell spraying a
wet trail of infected brains behind it.</p>
<p class="western5">“Come on! We’ll make it!” Ali whooped
triumphantly.</p>
<p class="western5">Buoyed on by the sniper’s intervention, Ali
surged on through the crowd.</p>
<p class="western5">A prepubescent girl in a grimy pink top with
her arms outstretched came staggering over like a sleepwalker. At
the last moment Ali dodged her bony fingers and planted his pipe
straight across her face.</p>
<p class="western5">He didn’t stop to see if he’d floored the
zombie. He didn’t have to immobilize every one of them—he merely
had to clear his way to the plaza.</p>
<p class="western5">The next zombie stepped into Ali’s path. It
was an old woman with wild grey hair populated with twigs, old
leaves and other tangled up pieces of detritus. She hissed through
a gash in her cheek as she lunged at him.</p>
<p class="western5">Ali sidestepped her and elbowed the deceased
crone in the head as she passed. The flesh under the blow squelched
and the old woman fell, her arms flailing out furiously all the way
to the ground.</p>
<p class="western5">A thrashing arm caught Ray by surprise,
tripping him.</p>
<p class="western5">“Ali!” Ray bellowed as he tumbled to the
ground.</p>
<p class="western5">Ali glanced round to see a mob of zombies
close in on Ray. A shot rang out and one of the mob members
collapsed, but it was futile. Ali knew there were too many to
shoot. All he could do was outrun them.</p>
<p class="western5">Ray cried out, “Help me!”</p>
<p class="western5">Ali froze. A strong gust of wind rushed
passed his face. Down the street over the heads of the undead he
saw a glorious sight. A blue and white helicopter was descending
into the square. The morning light bounced off its windows and sent
sparkling beams off in every direction. As the chopper softly
lowered he could see people inside. With one last effort he could
barge past the hundred or so zombies between him and safety.</p>
<p class="western5">“Ali!” a voice from behind begged.</p>
<p class="western5">Ali spun round to see Ray on all fours. The
clearing Ali had bludgeoned was rapidly diminishing as the
surrounding zombies closed in on their stricken meal.</p>
<p class="western5">Ali looked over his shoulder at the
descending helicopter, then back at Ray. He bounced back on the
balls of his feet and doubled back to his friend. As he passed he
took relish in stomping on the old crone’s face. Barrelling forward
he flung his arm round wildly, clattering three or four zombies
with his pipe.</p>
<p class="western5">The tactic hadn’t worked as well as Ali had
hoped. None of the zombies had been destroyed and none had been
forced back. Ali swung out again this time with more focus. He
clobbered the zombie directly in his path over the head flooring
him. As the creature started to fall he kicked out at the next
closest, pushing it away and then driving through the gap.</p>
<p class="western5">In front of him were a crowd of zombies, all
with their backs to him, forming a knot. Both hands on the metal
pipe, he brought the cudgel down with all his might. The zombie
collapsed and Ali thrust his free hand down to grab Ray.</p>
<p class="western5">With an inhuman bellow, Ali jerked as hard as
he could.</p>
<p class="western5">Ray’s scrawny body shot up through the gap.
Ali maintained his grip and backpedalled, pulling Ray with him. Ray
struggled to find his footing as he was dragged along.</p>
<p class="western5">“My glasses!” Ray panted. “I can’t see!”</p>
<p class="western5">“Forget ‘em,” Ali spat.</p>
<p class="western5">The path ahead was now awash with rotting
corpses and although he could hear the throb of the engine he could
no longer see the helicopter.</p>
<p class="western5">Needing all of his strength, Ali let go of
his friend and planted both hands firmly around the base of the
pipe. He swung the pipe as he pushed forward. Like some ancient
berserker he cleaved at the enemy with a feral rage. Again and
again his weapon battered down.</p>
<p class="western5">“<i class="calibre3">Get… out… of… ma… fuckin’… way…</i>”</p>
<p class="western5">With each word the metal pipe swung.</p>
<p class="western5">But with each blow he was moving forward less
and less.</p>
<p class="western5">Ray screamed from behind, “Ali!”</p>
<p class="western5"> <br class="calibre1"/></p>
<p class="c2">* * *</p>
<p class="western5"> <br class="calibre1"/></p>
<p class="western5">The skids of the chopper kissed the pavement.
Cahz threw open his door and hopped down onto the abandoned parking
lot. As he shut the door he caught the concerned look on Idris’
face. The pilot had a rule about landing in country and that was
DON’T.</p>
<p class="western5">Already the smell of rot was assaulting his
nostrils—the fusty mix of decomposing flesh and rank bile. Back on
board the ship that served as his and his team’s home base,
surrounded by hundreds of miles of open sea, the collapse of man’s
supremacy rarely impinged. Here, feet on the fractured tarmac, it
was obvious the dead held dominance.</p>
<p class="western5">“What’s the plan, boss?!” came a shout from
Cannon above the noise of the engine.</p>
<p class="western5">Rather than trying to yell above the din of
the rotors, Cahz made a simple hand gesture and the two men jogged
off.</p>
<p class="western5">The ground beneath his feet was strewn with
debris. Broken glass, litter, indistinguishable hunks of metal, a
thousand and one household items discarded during the Rising. A
twist of aluminium tubing hidden behind a clump of weeds snagged
Cahzs’ boot, causing him to stumble. He glanced back fleetingly
before regaining his stride. He was aware of the adrenalin coursing
through his veins, heightening his every sense, almost slowing down
time.</p>
<p class="western5">Up ahead he saw the stone corner of a tall
office building. Around that corner the survivors were fighting
through hordes of the undead. From there he and Cannon could be
well covered, in easy reach of the chopper and in a good position
to help the fleeing survivors.</p>
<p class="western5">“Here,” Cahz said. “We’ll cover them from
here.”</p>
<p class="western5">He turned the corner and a body slammed hard
up against him, pressing so closely he couldn’t swing his carbine
round. Out of instinct his hand grabbed the figure, ready to push
them out of biting range. In that fraction of a second Cahz hadn’t
registered who had run into him.</p>
<p class="western5">A young woman gripped by fear and holding a
girl in her arms stood panting beside him. Her body trembled in his
grasp.</p>
<p class="western5">Cahz used his grip to propel her on round the
corner. “Go to the helicopter!”</p>
<p class="western5">Turning back to Cannon, he said, “Watch my
six.” He knew his old buddy would have anticipated his tactic but
his sense of caution demanded he say it anyway.</p>
<p class="western5">Cannon gave a smile and a nod. “Sure thing,
boss!”</p>
<p class="western5">Cahz turned and took up position. In a
different conflict against a different enemy he’d been taught to
stick to cover, to stay low, but that was a long time ago. He
didn’t concern himself with redundant doctrine. This enemy didn’t
shoot back.</p>
<p class="western5">Cahz stepped out from the cover of the
building and, standing up straight, braced the butt of the carbine
to his shoulder. He peered through the scope and selected his first
target.</p>
<p class="western5">Not far from him a zombie came hobbling after
the young woman he had directed to the helicopter. It was a gaunt
creature; a woman in life, now a sagging mass of sticky, syrupy,
brown pustulence; wild sprouts of wispy hair on an otherwise
leathery scalp, torn dress caked to her rotten flesh. Its lips were
drawn back in a snarl, exposing a line of cragged and equally
soiled teeth. Its pathetic limp was mirrored in grasping hands,
arms glued to its sides, forearms outstretched from the elbows
only. The decrepit beast looked like it had been dunked in oil like
some wretched sea bird caught in an oil slick.</p>
<p class="western5">Cahz pulled the trigger. A spray of bullets
ripped through the zombie’s face, destroying its head.</p>
<p class="western5">“Shit,” Cahz said. He thumbed a catch on the
side of his carbine and flicked it from burst fire to single shot.
He chastised himself for the waste of ammunition. “Get it
together.”</p>
<p class="western5">He aimed his gun again and in two smooth
shots he obliterated another two walking dead. Another two shots
and the path ahead was cleared for the next batch of survivors.</p>
<p class="western5">The two men came lurching towards him, an old
woman supported between their arms. Cahz could hear a stream of
encouragement from the young men as they hauled the exhausted woman
along.</p>
<p class="western5">“Keep going down to the chopper!” Cahz
shouted to the trio.</p>
<p class="western5">Before taking aim again, he surveyed the
street. Along the sidewalks, spilling onto the roads, staggering
between the mangled cars, came an army of cadavers. All wore the
same uniform of tattered brown stained clothes, all with the same
pallid grey faces.</p>
<p class="western5">Hundreds—if not thousands—of infected
corpses, shambling forward, charging in slow motion.</p>
<p class="western5">But there among the palsied attackers was a
knot of fury. With lighting strikes a tall balding man with dark
hair was battling obstinately against the swarming horde.</p>
<p class="western5">Cahz braced his weapon and lent his
assistance to the fight. Framed in the dark circle of his sight, he
took aim and fired. Tracking from left to right he fired, trying to
weed out the zombies on either side. He couldn’t risk a shot at the
knot within the mêlée, so entangled in the combat were the targets
that the risk of hitting the men he was trying to save was too
likely.</p>
<p class="western5">A spray of blood, red and warm and alive,
spurted from the brawl. Cahz caught the spurt in his view as he
picked targets. Had a shot missed a zombie to strike the survivor?
Or had a zombie’s bite found an artery?</p>
<p class="western5">He knew he couldn’t dwell on the reason. All
he could do was continue to obliterate zombies.</p>
<p class="western5">The scope went black. Cahz pulled back from
his blinkered view and took a shocked step backward.</p>
<p class="western5">Arms outstretched, head clocked at a crooked
angle, a zombie was trampling its way towards him. It was no more
than a couple of lumbering steps away and Cahz had only known of
its approach because it had blocked his view.</p>
<p class="western5">He adjusted his aim and fired. The reanimated
shop worker’s head lurched back, its brains annihilated by the
bullet passing through its skull.</p>
<p class="western5">Cahz counted himself lucky. He quickly
scanned the surrounding area and focused his attention back on the
knot of survivors.</p>
<p class="western5">The street was choked with zombies now. Cahz
dipped in and out of using his scope, anxiously trying to spot the
man with the pipe. He peered through the throng, hoping to glimpse
the arm raise that held the sturdy grey pipe. But there was
nothing.</p>
<p class="western5">“Boss, this is Bates,” Cahz heard over his
earpiece. “I’m running dry and there’s no let up.”</p>
<p class="western5">Among the legions of walking dead, Cahz could
see no signs of a struggle.</p>
<p class="western5">“Angel, have you got eyes on the other
survivors?” Cahz asked, hoping the view from the sniper’s vantage
point would bring good news.</p>
<p class="western5">A trio of zombies steadily advanced on the
street corner. Getting too close for comfort, Cahz floored them
with three well-placed shots.</p>
<p class="western5">Angel hadn’t replied.</p>
<p class="western5">Cahz again toggled his radio. “Angel, come
in.”</p>
<p class="western5">“Lieutenant,” came Angel’s Russian tone, “I
have situation.”</p>
<p class="western5">Cahz turned and scanned the skyline.
Silhouetted on one of the rooftops he saw the team sniper. She was
standing in a firing position, shooting at something on the roof.
In a matter of seconds she had fired a whole magazine from her
pistol. Whatever threat she faced, it wasn’t finished with her.</p>
<p class="western5">Cahz sighted his rifle on her to get a
clearer view through his scope. The feathery white clouds and the
low sun scattered the morning light, leaving Cahz to see only the
dark shadow of her silhouette. Her ponytail bobbed as she hastily
reloaded her pistol. Then, without warning, she turned and threw
herself off the rooftop.</p>
<p class="western5">Lost from view, Cahz drew back from his
sight, frantically scanning for her.</p>
<p class="western5"><i class="calibre3">There</i>.</p>
<p class="western5">Three or four floors from the bottom of the
building, she dangled on her safety line.</p>
<p class="western5">The rooftop now became full of shambling
corpses. As they reached the edge of the roof they slowed, confused
by their lack of prey. Then the first of them fell. Whether it had
stumbled, was pushed from behind, or just hadn’t stopped walking,
the result was the same. The corpse tumbled down the face of the
building.</p>
<p class="western5">The plummeting body narrowly missed Angel as
she clung to the building’s façade.</p>
<p class="western5">Now a torrent of undead plunged from the
roof. Dozens of brainless cadavers hurtled the eight storeys to
pile up in a heap of splattered and shredded flesh.</p>
<p class="western5">Transfixed by the drama playing out across
the plaza, Cahz watched on, his heart pounding. The worst of it was
he knew there was nothing he could do to help her. Unconsciously
his fingers caressed the toggle on his radio. As much as he wanted
to call her he knew better than to distract her. The sniper acted
alone, compromising her own safety for the sake of her comrades.
Cahz turned his attention back to the street corner and dispatched
the fresh batch of zombies encroaching on his position.</p>
<p class="western5">Back along the street there were no signs of
life. No glimpse of the survivors, not even a knot of undead that
might indicate a struggle. Nothing.</p>
<p class="western5">Cahz fired a few well-placed shots to thin
out the zombies and took one last look into the mob. Reluctantly he
turned to his buddy.</p>
<p class="western5">“Time to go, big guy,” he said as he patted
Cannon on the shoulder.</p>
<p class="western5">He toggled his mic. “Okay people, time to bug
out. Everyone back to the bird.”</p>
<p class="western5">With Cannon in tow, Cahz jogged back to the
chopper. The air had the tart taste of spent powder mingling with
the reek of festering bodies.</p>
<p class="western5">Cahz kept an eye on the team sniper as he
made his way back. Dangling from her line, like a spider, Angel had
pulled her side arm and was popping shots into the small gathering
of zombies lucky enough to remain mobile after their dive off the
roof. Her aim looked clumsy for the veteran shot she was. Then Cahz
realised she was using her right hand, her left arm hanging loose
by her side.</p>
<p class="western5">“Cahz, we’ve a problem,” the pilot’s voice
came over the radio.</p>
<p class="western5">Just yards from the chopper, Cahz didn’t
bother to reply over the mic.</p>
<p class="western5">“Cannon, go give Angel a hand,” Cahz
ordered.</p>
<p class="western5">“You got it,” Cannon replied. He peeled off
and jogged over to the stricken sniper. He was a huge man, almost
as wide as he was tall, but more nimble than a soldier half his
bulk. With startling agility he powered over the parking lot.</p>
<p class="western5">Gathered around the chopper were the people
who had made it through the zombies. They all looked gaunt and
exhausted. The young woman, the first to make it past Cahz, was
bent double, dry heaving from the exertion. The other survivors
didn’t look too much better.</p>
<p class="western5">The young men had instinctively assumed a
picket and were watching nervously the advance of the zombies
towards the chopper.</p>
<p class="western5">Cahz turned his head and double-checked
behind him. A mob of undead had followed him round from the street
but their sluggish gait meant there would be a few minutes before
they reached the helicopter.</p>
<p class="western5">Bates, at the window of the chopper, was
struggling to hold a conversation with Idris over the noise of the
blades and the nearby ghetto blaster.</p>
<p class="western5">“What’s the problem?!” Cahz called out as he
reached the chopper.</p>
<p class="western5">“Are you counting heads?!” Idris hollered
back.</p>
<p class="western5">The disparate group were strung out around
the chopper. The young woman was bent double, the eight-year-old
girl she’d been carrying was comforting her with her hand on her
back. The old woman was unsuccessfully trying to calm the baby in
her arms. Even over the deafening sound of the chopper and the
blaring ghetto blaster the child’s screeching still cut through it
all.</p>
<p class="western5">Beside him, trying to look like he was
working hard at solving a mental problem, Bates scratched at the
short blond stubble on his chin.</p>
<p class="western5">Cahz suddenly understood the dilemma. “Ah,
shit!”</p>
<p class="western5">Before he could ponder the problem further
the young woman stepped in.</p>
<p class="western5">“Where are the others?” Sarah asked, red
cheeked and still gulping for breath.</p>
<p class="western5">“I’m sorry, ma’am,” Cahz said as mournfully
as he could while shouting above the noise. When he saw the woman’s
face drop he threw in, “I waited as long as I could.”</p>
<p class="western5">He looked away from the woman and the burning
pain in her eyes. He felt guilty for not saving the others but yet
he felt worse still for the news he was about to break.</p>
<p class="western5">His gloved hand found a seam of rounded
rivets running down a length of the chopper’s skin. He brushed his
fingertips over the tiny bumps as he pondered.</p>
<p class="western5">“Could we get everyone on-board and try to
find somewhere safe to set down?” Cahz knew how stupid an idea that
was even before he’d finished saying it.</p>
<p class="western5">“Where?” Idris shrugged, playing through
Cahz’s suggestion. “Look, we’d be struggling to get airborne with
the extra weight even if you could cram everyone in. And if we
could take off, where would we get the extra fuel we’d need to get
back to Ishtar?”</p>
<p class="western5">“What’s the problem?” Sarah interjected,
catching snippets of the conversation.</p>
<p class="western5">“Ma’am, the chopper only seats five, maybe
six at a squeeze,” Cahz admitted. He saw the woman’s eyes dart
across the gathered people, taking a mental note of the numbers.
“And there are ten of us.”</p>
<p class="western5">Cahz frantically tried to pull the problem
apart. “Don’t suppose the girl and the baby will be a problem. They
can sit on someone’s knee.” Looking across the abandoned car park,
the army of undead were doggedly drawing closer.</p>
<p class="western5">The big soldier, Cannon, jogged up, Angel
trailing behind. Along with his own support weapon, Cannon had
Angel’s prize possession, her sniper rifle, draped over his
shoulder. Cahz knew Angel’s injury must be severe if she was
allowing someone to carry it for her.</p>
<p class="western5">Before Cahz could ask Angel what was wrong,
the young woman broke in again.</p>
<p class="western5">“That still leaves us four seats short,” she
said, still focused on the problem.</p>
<p class="western5">Cannon said something that Cahz missed over
the noise and the demands for his attention.</p>
<p class="western5">“The kids’ll fit in fine,” Cahz heard Idris
summarise, “but we’re pushing the weight limit. We’ve got enough
fuel for the five of us and a few of the pus bags, but they weigh
next to nothing. Even if we do stuff this bird full, we’ll be short
on fuel.”</p>
<p class="western5">Cannon and the young woman were listening
intently, although both cast more than an occasional glance at the
encroaching zombies.</p>
<p class="western5">“Okay, there’s no drag if we don’t use the
net,” Idris said, “but we’ll still splash down who knows how short
of the ship. And what if the weather turns and we meet a strong
headwind? We’ll just ditch a whole lot sooner.”</p>
<p class="western5">The scrawny male survivor, impatient to get
moving, spoke up, “Could some of us get carried in the cargo
net?”</p>
<p class="western5">“No, we can’t take the weight or the drag,
son,” Idris repeated.</p>
<p class="western5">“Anyways, you’d die of exposure before we got
back to the ship,” Bates added. “It’s bad enough just getting
winched up, but being under that thing for two hundred miles? No
way you’d make it.”</p>
<p class="western5">“No need for a seat for me dear,” came a
frail voice from behind.</p>
<p class="western5">The old woman with the baby looked
tearful.</p>
<p class="western5">“What do you mean?” Sarah asked.</p>
<p class="western5">The baby was hoisted to one side and the old
woman pulled her collar down. Where the curve of her neck melded
into the shoulder there was an ugly bite mark. Already a deep
purple hue surrounded the raged oval of torn skin.</p>
<p class="western5">“I’m sorry I couldn’t protect her,” the old
woman sobbed.</p>
<p class="western5">Cahz watched confused as the thick set
survivor walked up to the old woman. Slowly but purposefully he
reached down and eased away the swaddling from the child’s face.
The baby was screaming. Her cheeks red, her lips pursed, her small
lungs howled out a shrill cry. On the corner of the swaddling were
wet splodges of blood and across the small child’s face the trail
of a scratch mark.</p>
<p class="western5">“Shit,” Cahz whispered.</p>
<p class="western5">“Oh God no, Elspeth,” Sarah gasped.</p>
<p class="western5">“Must have happened when I fell,” the old
woman said, turning to the man next to her.</p>
<p class="western5">The thickset man stood transfixed by the
child. With the back of a finger he stroked the infant’s uninfected
cheek while tears ran down both their faces.</p>
<p class="western5">“I’m so sorry, Ryan,” she apologised.</p>
<p class="western5">“Boss,” Bates broke in, “I’m out of ammo and
they’re close.”</p>
<p class="western5">“We don’t have time for this, Cahz,” Cannon
agreed, a note of agitation in his voice.</p>
<p class="western5">Cahz turned to his men and addressed them.
“Okay, listen up. This isn’t an order but we’ve more of a chance
down here than they do. I’m giving up my seat.”</p>
<p class="western5">“Jesus, Cahz, we haven’t survived this long
to get fucked by a handful of civvies,” Cannon protested
loudly.</p>
<p class="western5">Cahz looked his old friend in the eyes. “Like
I say, I can’t order you to stay.”</p>
<p class="western5">“You don’t give much of an option, Boss,”
Cannon said grudgingly. “We’ve stuck together since this shit came
down. If you’re stayin’ I’m stayin’.”</p>
<p class="western5">Cahz smiled and patted the big man on the
shoulder.</p>
<p class="western5">Bates tossed his head and said, “I’m taking
my seat.”</p>
<p class="western5">“I stay,” Angel volunteered.</p>
<p class="western5">Ryan stepped in. “No, lady. Your arm’s
busted. I’ll stay back.”</p>
<p class="western5">“Ryan you can’t—” Sarah started.</p>
<p class="western5">“These boys might have the firepower but they
don’t know the ground,” Ryan argued. “They’ve got a better chance
with one of us to guide them.”</p>
<p class="western5">Cahz rubbed the sweat from his upper lip with
his gloved finger. The zombies were now close enough to see their
gnarled teeth framing their gaping maws. A few more seconds and
they would be upon them.</p>
<p class="western5">There might have been a better way to solve
this problem, but Cahz knew they didn’t have the time to find it.
He said, “That’s that settled.”</p>
<p class="western5">Cahz grabbed the young woman with both hands
and threw her into the chopper. The woman was too shocked to resist
and the rotors were too noisy for him to hear her protests.</p>
<p class="western5">“Okay miss, in you go,” Cahz said in way of
preamble as he scooped up the young girl. As he shoved the girl
into the cabin, he called on the scrawny survivor, “You! In the
bird now!”</p>
<p class="western5">Nathan was ushered into the middle seat.</p>
<p class="western5">“Soon as you can, get back here and pick us
up,” Cahz said, looking at Idris. His attention then went
immediately to Bates, who was retrieving his equipment. “Bates,
leave that behind. How much juice is in those batteries?” Cahz
pointed at the beat up ghetto blaster.</p>
<p class="western5">“Not much, boss,” Bates replied with a shrug.
“They’re rechargeable and they’re pre-Zee. If you turn the sound
down a bit you might eke out another fifteen, twenty minutes, but I
guess about an hour is it.”</p>
<p class="western5">Cahz gave a nod. “Okay.”</p>
<p class="western5">“Boss!” Cannon’s deep voice bellowed.
“Gettin’ a bit close!”</p>
<p class="western5">The snarling growl of machine gun fire
overwhelmed the dawdle of the chopper blades as Cannon cut a sway
through the closest zombies.</p>
<p class="western5">“You looking for a decoy?” Bates asked.</p>
<p class="western5">“Yep,” Cahz replied.</p>
<p class="western5">Bates produced a modified land mine. It was a
green oblong with a slight banana curve. Unlike standard issue
mines, Bates had been busy modifying this one. One corner had what
appeared to be a travel alarm clock duct taped in place. A pair of
clumsy wires, intermittently hidden behind more silver duct tape,
wound their way into the back of the casing. Cahz had warned Bates
about tampering with explosives on more than one occasion, but now
wasn’t the time for a reprimand.</p>
<p class="western5">“Set a timer on it for, what, five minutes?”
Bates offered.</p>
<p class="western5">“Make it twenty,” Cahz said. “It’ll act as a
distraction. Maybe pull a few away from us.”</p>
<p class="western5">Bates made an adjustment to the timer before
setting it down and picking up the rest of his gear.</p>
<p class="western5">“You packing any more useful toys?” Cahz
asked as the soldier perched on the rear seat of the chopper.</p>
<p class="western5">“Yeah, sure.” Bates lay down his rifle and
unfastened the thigh pouches from his webbing. With a smile he
tossed the two packs at Cahz. “Two more claymores, two flares, a
smoke grenade and one MRE.”</p>
<p class="western5">Cahz caught the packs by their strapping.
“Ain’t planning on staying long enough to have to eat army rations.
Maybe we can tempt those motherfuckers to eat these instead.”</p>
<p class="western5">“Smear it all over you,” Bates teased. “Then
no fucker will want to bite you.”</p>
<p class="western5">Cannon shouted over the noise with some
urgency, “It’s gettin’ tight, boss!”</p>
<p class="western5">Cahz rapped his knuckles on the windscreen to
get the pilot’s attention. “Get these people out of here!”</p>
<p class="western5">Idris gave a nod.</p>
<p class="western5">Angel called out from her seat in the front,
“Cahz, it’s at least an eight hour turnaround!”</p>
<p class="western5">Eight hours was a long time out here and Cahz
knew it. But he cocked his head and smiled.</p>
<p class="western5">“Quicker you go the quicker you get back!” he
said.</p>
<p class="western5">“Good luck, Cahz.” Angel passed out her
sidearm and a bundle of magazines. There was an assortment of
magazines for the sidearm and one chunkier magazine for her rifle.
The larger of the clips bore the unfamiliar Cyrillic writing Cahz
had seen on much of her Russian equipment.</p>
<p class="western5">Cahz looked her in the eye. “You sure?”</p>
<p class="western5">“I want empties back,” Angel warned. “Since
Izhmash closed, are bitch to get hold of.”</p>
<p class="western5">Cahz nodded, taking the friendly jibe.</p>
<p class="western5">Cahz firmly handed Angel’s pistol to Ryan.
“Okay, we need somewhere high and defendable. Which way?”</p>
<p class="western5">Ryan took the gun in his hand. “This
way.”</p>
<p class="western5">“Stay close, stay sharp, stay alive!” Cahz
hollered.</p>
<p class="western5"> <br class="calibre1"/></p>
<p class="western5"> <br class="calibre1"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tmp_585a07e3e5e55219dccf95a383be276f_OzNgdZ.ch.fixed.fc.tidied.stylehacked.xfixed_split_004.vue?e5831b9a